import React from 'react';
import noop from 'lodash/noop';

import { useCurrentUser } from '@atlassian/jira-platform-services-user-current/src/main.tsx';
import { IdentityUserAri } from '@atlassian/ari/identity/user';
import { useNestedItemDragAndDrop } from '@atlassian/navigation-drag-and-drop';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';

import { AnyAri } from '@atlassian/ari/any-ari';
import { BoardItem, type BoardItemProps } from './BoardItem.tsx';
import { useDragAndDropReorderingAnalytics } from './drag-and-drop-reorder-analytics.tsx';

type DraggableBoardItemProps = Omit<BoardItemProps, 'dragAndDropState'>;

export function DraggableBoardItem(props: DraggableBoardItemProps) {
	const { edge, projectKey } = props;
	const { fireAnalyticsEvent } = useDragAndDropReorderingAnalytics();
	const {
		data: {
			user: { accountId },
		},
	} = useCurrentUser();
	const cloudId = useCloudId();

	const ownerAri = IdentityUserAri.create({ userId: accountId || 'UNKNOWN' }).toString();

	const data = {
		id: edge?.node?.boardId?.toString() || '',
		label: edge?.node?.name || '',
	};

	const entityAri = AnyAri.create({
		cloudId,
		resourceType: 'project',
		resourceId: projectKey,
		resourceOwner: 'jira',
	}).toString();

	const dragAndDropState = useNestedItemDragAndDrop({
		entityAri,
		ownerAri,
		data,
		group: 'SIDE_NAVIGATION_PROJECT_BOARDS',
		item: undefined,
		isExpandable: false,
		isExpandOrFlyoutOpen: false,
		id: edge?.node?.boardId?.toString() || '',
		isDragAndDropEnabled: true,
		onExpandFlyoutToggle: noop,
		fireAnalyticsEvent,
	});
	return <BoardItem {...props} dragAndDropState={dragAndDropState} />;
}
